import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { Combobox } from '@/common/ui/combobox'
import useQueryGetChannels from '@/modules/manage-player/api/hooks/useQueryGetChannels'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useMemo, ReactNode } from 'react'

interface PlayerSearchControlsProps {
	searchPlaceholder?: string
	searchHint?: string
	showChannelFilter?: boolean
	showExcludeFreeCredit?: boolean
	additionalFilters?: ReactNode
}

export default function PlayerSearchControls({
	searchPlaceholder = 'ค้นหา...',
	searchHint = 'สามารถค้นหาด้วย: เบอร์โทร, IP Address, บัญชีธนาคาร, เลขบัญชี',
	showChannelFilter = true,
	additionalFilters,
}: PlayerSearchControlsProps) {
	const { data: channelsData } = useQueryGetChannels({
		skip: 0,
		take: 100,
		isActive: true,
	})
	const { channelFilter, setChannelFilter } = useTablePagination()

	const channelOptions = useMemo(
		() => [
			{
				label: 'ทั้งหมด',
				value: '',
			},
			...(channelsData?.data.map((channel) => ({
				label: channel.name,
				value: channel.name,
			})) || []),
		],
		[channelsData],
	)

	return (
		<div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-2">
			<DataTableSearch
				placeHolder={searchPlaceholder}
				searchHint={searchHint}
			/>
			<DataTableResetFilter />
			{showChannelFilter && (
				<Combobox
					options={channelOptions}
					placeholder="เลือกช่องทาง"
					value={channelFilter}
					onValueChange={setChannelFilter}
				/>
			)}
			{additionalFilters}
		</div>
	)
}
